import React from 'react';
import { Box, Typography } from 'housecall-ui';

import { CategoryType, IndustryType } from 'components/OnlineBookingSettings/types/types';

import { useServices } from '../hooks/useServices';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

import { CategoryCard } from './CategoryCard';
import { ScrollableContent } from './ScrollableContent';

export const CategoryList = () => {
  const {
    state: { orgUuid },
    dispatch,
    actions,
  } = useOnlineBookingReducer();
  const { data: response } = useServices({ orgUuid });

  const clickHandler = (industry: IndustryType, category: CategoryType) => () => {
    dispatch(actions.selectIndustry(industry));
    dispatch(actions.selectCategory(category));
    dispatch(actions.nextStep());
  };

  return (
    <ScrollableContent>
      {response?.data?.map((industry) => {
        return (
          <Box key={industry.uuid}>
            <Typography gutterBottom variant="subtitle1">
              {industry.name}
            </Typography>
            {industry.categories.map((category) => (
              <CategoryCard
                key={category.uuid}
                title={category.name}
                description={category.services.map((service) => service.name).join(', ')}
                onClick={clickHandler(industry, category)}
              />
            ))}
          </Box>
        );
      })}
    </ScrollableContent>
  );
};
